// extracted by mini-css-extract-plugin
export default {"Images":"Product_Images__Kx3qu"};